import React, {useEffect, useState, useRef} from 'react'
import { stringSimilarity } from "string-similarity-js";
import { useDispatch, batch } from 'react-redux'
import SearchIcon from '../icons/search.svg'
import LoadingIcon from '../icons/coag-outline.svg'
import ResetIcon from '../icons/close.svg'

import { IconList } from './Icons.js'
import {
  setInfoPanel,
  showMapPanel,
  showSidebar,
} from '../slices/ui'

import {
  setMapExtent,
} from '../slices/map'

import { useSearch } from '../api'

const Item = (props) => {
  const {id, type, quadhash, extent, title, subtitle, icons} = props
  const dispatch = useDispatch()
  const handler = (e) => batch(() => {
    dispatch(showMapPanel(true))
    dispatch(showSidebar(null))
    dispatch(setMapExtent({ bounds: extent }))
    dispatch(setInfoPanel({
      type: type,
      id: id,
      quadhash: quadhash
    }))
  })

  return (
    <li className="sidebar__search__result button secondary fade-in slow" 
        onClick={handler}>
      <div>
        {title},<span>{subtitle}</span>
      </div>
      { icons && (
        <div className="pwa__amenities__list">
          <IconList icons={icons} />
        </div>
      )}
    </li>
  )
} 


const ItemsList = ({items}) => {

  return (
    <>
      {items.length === 0
        ? <p>No users found</p>
        : <ul className="sidebar__search__results">
          {items.map((item, key) => <Item {...item} key={key} />)}
        </ul>
      }
    </>
  )
}

const SearchWaypoint = (props) => {
  const [serverSearch, setServerSearch] = useState('')
  const [filteredWaypoints, setFilteredWaypoints] = useState([])
  const waypoints = useSearch({search : serverSearch}) || null
  const searchInput = useRef()
  const loading = waypoints === null

  useEffect(() => {
    if (waypoints?.length > 0) {
      setFilteredWaypoints(waypoints)
    }
  }, [waypoints]) 

  const removeAccents = (str) => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  const filterItems = (searchTerm) => {
    const items = waypoints ? [] : waypoints.map((waypoint) =>[
      waypoint,  stringSimilarity(removeAccents(waypoint.title).toLowerCase(), searchTerm)  
    ])
    const filteredItems = items.filter((item) => item[1] > .6);
    filteredItems.sort((item) => [parseInt(item[0] * 5), -item[1].length])
    setFilteredWaypoints(filteredItems.map((item) => item[1]))
    if (waypoints && (filteredItems.length < 5 || searchTerm.length < serverSearch.length)){
      setServerSearch(searchTerm)
    }
  }

  const handleInputChange = (e) => {
    const searchTerm = removeAccents(e.target.value.toLowerCase())
    filterItems(searchTerm)
  }

  const resetSearchTerm = (e) => {
    searchInput.current.value = '';
    filterItems('')
  }

  return (
    <>
      <div className="sidebar__search">
        {loading ? <LoadingIcon className="rotate" />: serverSearch ? <ResetIcon className="fade-in" onClick={resetSearchTerm}/> : <SearchIcon className="fade-in"/> }
        <input
          type="text"
          ref={searchInput}
          onChange={handleInputChange}
          placeholder='Type to search'
        />
      </div>
      {!loading && <ItemsList items={filteredWaypoints} />}
    </>
  )
}

export default SearchWaypoint
